import { createSlice } from "@reduxjs/toolkit";

export type GCGroup = {
  id: number | string,
  user: any,
  owner: any,
  edit: boolean,
  isLoading: boolean,
  isSuccess: boolean,
  member_groups: any[],
  memberGroupUsers: any[],
  groupName: string,
  groupImage: any, // Initially no image
  groupIsPublic: boolean,
  piiRequired: boolean,
  isPaid: boolean,
  groupMainImage: any, // Main image file from state
  groupDesc: string, // Description from state
  groupAnnouncements: { value: string }[],
  groupWebURLs: string, // You can replace this with the actual value
  groupApprovalRequired: boolean,
  groupIsLimited: boolean, // Represents whether group membership is limited
  groupMemberShipFeeAmount: number, // Membership fee amount
  isMonthly: boolean, // Static value for payment frequency
  groupPaymentField: string, // Additional payment field
  groupPaymentDescription: string, // Payment description
  role: string,
  posts_count: number
}

export const gcGroupInitialState: GCGroup = {
  user: undefined,
  owner: undefined,
  id: "",
  edit: false,
  isLoading: false,
  isSuccess: false,
  member_groups: [],
  memberGroupUsers:[],
  groupName: "",
  groupImage: null,
  groupIsPublic: true,
  piiRequired: false,
  isPaid: false,
  groupMainImage: null,
  groupDesc: "",
  groupAnnouncements: [
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
  ],
  groupWebURLs: "",
  groupApprovalRequired: false,
  groupIsLimited: false,
  groupMemberShipFeeAmount: 0,
  isMonthly: true,
  groupPaymentField: "",
  groupPaymentDescription: "",
  role:"",
  posts_count:0
}

const gcGroupReducer = createSlice({
  name: "gcGroup",
  initialState: gcGroupInitialState,

  reducers: {
    setGroupInfo: (state, action) => {
      // Update only fields that are provided in the payload
      const {
        user,
        owner,
        id,
        edit,
        groupName,
        groupImage,
        groupIsPublic,
        piiRequired,
        groupMainImage,
        groupDesc,
        groupAnnouncements,
        groupWebURLs,
        groupApprovalRequired,
        groupIsLimited,
        memberGroupUsers,
        groupMemberShipFeeAmount,
        isMonthly,
        isPaid,
        groupPaymentField,
        role,
        posts_count,
        groupPaymentDescription,
      } = action.payload;

      if (user !== undefined) state.user = user;
      if (owner !== undefined) state.owner = owner;

      if (isPaid !== undefined) state.isPaid = isPaid;
      if (role !== undefined) state.role = role;

      if (id !== undefined) state.id = id;
      if (edit !== undefined) state.edit = edit;
      if (posts_count !== undefined) state.posts_count = posts_count;

      if (memberGroupUsers !== undefined) state.memberGroupUsers = memberGroupUsers;
      if (groupName !== undefined) state.groupName = groupName;
      if (groupImage !== undefined) state.groupImage = groupImage;
      if (groupIsPublic !== undefined) state.groupIsPublic = groupIsPublic;
      if (piiRequired !== undefined) state.piiRequired = piiRequired;
      if (groupMainImage !== undefined) state.groupMainImage = groupMainImage;
      if (groupDesc !== undefined) state.groupDesc = groupDesc;
      if (groupAnnouncements !== undefined)
        state.groupAnnouncements = {
          ...state.groupAnnouncements,
          ...groupAnnouncements,
        };
      if (groupWebURLs !== undefined) state.groupWebURLs = groupWebURLs;
      if (groupApprovalRequired !== undefined)
        state.groupApprovalRequired = groupApprovalRequired;
      if (groupIsLimited !== undefined) state.groupIsLimited = groupIsLimited;
      if (groupMemberShipFeeAmount !== undefined)
        state.groupMemberShipFeeAmount = groupMemberShipFeeAmount;
      if (isMonthly !== undefined) state.isMonthly = isMonthly;
      if (groupPaymentField !== undefined)
        state.groupPaymentField = groupPaymentField;
      if (groupPaymentDescription !== undefined)
        state.groupPaymentDescription = groupPaymentDescription;
    },
    clearGroupInfo: (state) => {
      state.id = "";
      state.edit = false;
      state.groupName = "";
      state.groupImage = null;
      state.groupIsPublic = true;
      state.piiRequired = false;
      state.groupMainImage = null;
      state.groupDesc = "";
      state.memberGroupUsers=[];
      state.groupAnnouncements = [
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
      ];
      state.groupWebURLs = "";
      state.groupApprovalRequired = false;
      state.groupIsLimited = false;
      state.groupMemberShipFeeAmount = 0;
      state.isMonthly = true;
      state.isPaid = false;
      state.groupPaymentField = "";
      state.groupPaymentDescription = "";
      state.role="";
      state.posts_count=0;
    },
  }
});

export const { setGroupInfo, clearGroupInfo } =
  gcGroupReducer.actions;
export default gcGroupReducer.reducer;
